import actions from './apiActions.js'
import state from './apiState.js'
import mutations from './apiMutations.js'
import getters from './apiGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
